export enum UserRole {
  CLINIC = 'clinic',
  DOCTOR = 'doctor',
  PATIENT = 'patient',
  PSYCHO = 'psycho'
}